export default __webpack_public_path__ + "static/media/21.a2964baa.svg";